export const theme = {
  colors: {
    brand: {
      green: {
        primary: {
          1: '#EBFAF7',
          2: '#B0E8DC',
          3: '#76D0BE',
          4: '#3BB99F',
          5: '#00A180',
          6: '#008F72',
          7: '#007E64',
          8: '#006C56',
          9: '#005A48',
          10: '#00493A',
          11: '#00372C',
        },
      },
      orange: {
        secondary: {
          1: '#FFF9F5',
          2: '#FFE7D8',
          3: '#FFD6BB',
          4: '#FFC49D',
          5: '#FFB380',
          6: '#DE996B',
          7: '#BD7F55',
          8: '#9C6540',
          9: '#7B4B2B',
          10: '#5A3115',
          11: '#391700',
        },
      },
      grayscale: {
        1: '#FFFFFF',
        2: '#FAFAFA',
        3: '#F4F4F5',
        4: '#E4E4E7',
        5: '#D4D4D8',
        6: '#A1A1AA',
        7: '#71717A',
        8: '#52525B',
        9: '#3F3F46',
        10: '#27272A',
        11: '#18181B',
        12: '#09090B',
      },
      white: {
        500: '#FFFFFF',
      },
    },
    aux: {
      blue: {
        info: {
          1: '#EFF6FF',
          2: '#DBEAFE',
          3: '#BFDBFE',
          4: '#93C5FD',
          5: '#60A5FA',
          6: '#3B82F6',
          7: '#2563EB',
          8: '#1D4ED8',
          9: '#1E40AF',
          10: '#1E3A8A',
          11: '#172554',
        },
      },
      red: {
        danger: {
          1: '#FEF2F2',
          2: '#FEE2E2',
          3: '#FECACA',
          4: '#FCA5A5',
          5: '#F87171',
          6: '#EF4444',
          7: '#DC2626',
          8: '#B91C1C',
          9: '#991B1B',
          10: '#7F1D1D',
          11: '#450A0A',
        },
      },
      yellow: {
        warning: {
          1: '#FFFBEB',
          2: '#FEF3C7',
          3: '#FDE68A',
          4: '#FDE047',
          5: '#FACC15',
          6: '#EAB308',
          7: '#CA8A04',
          8: '#A16207',
          9: '#854D0E',
          10: '#713F12',
          11: '#422006',
        },
      },
    },
  },
}
